/* ============================================
   BBC EXPERIENCE — JavaScript
   Chargé en defer dans theme.liquid, APRÈS global.js.
   Chaque module s'auto-désactive si son markup est absent.
   La séquence d'entrée est pilotée par html.bbc-entering,
   posée par un script inline dans <head> (1 fois par session,
   jamais si prefers-reduced-motion).
   ============================================ */

(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var ENTERING = root.classList.contains('bbc-entering');

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    var t;
    return function () { var args = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(null, args); }, ms); };
  }

  /* ── 1. SÉQUENCE PORTES VERSAILLES ──────────────────── */
  
  var heroChars = [];
  function splitHeroTitle() {
    if (!ENTERING || prefersReduced) return;
    var heading = $('.hero__title');
    if (!heading) return;
    var wordSpans = $$('.hero__title .word > span');
    if (!wordSpans.length) return;
    var fullText = wordSpans.map(function (s) { return s.textContent; }).join(' ');
    heading.setAttribute('aria-label', fullText);
    wordSpans.forEach(function (span) {
      var text = span.textContent;
      span.textContent = '';
      span.setAttribute('aria-hidden', 'true');
      var frag = doc.createDocumentFragment();
      for (var i = 0; i < text.length; i++) {
        var c = doc.createElement('span');
        c.className = 'bbc-char';
        c.textContent = text.charAt(i);
        frag.appendChild(c);
        heroChars.push(c);
      }
      span.appendChild(frag);
    });
  }
  function animateHeroTitle() {
    heroChars.forEach(function (c, i) {
      setTimeout(function () { c.classList.add('visible'); }, 57 + i * 32);
    });
  }

  /* ── 3. POUSSIÈRE D'OR — particules d'ambiance ── */
  function initScrollProgress() {
    var bar = doc.getElementById('bbc-progress');
    var head = $('.site-header');
    var menu = $('.mobile-menu');
    if (!bar && !head) return;

    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY;
      if (bar) {
        var total = doc.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (total > 0 ? (y / total) * 100 : 0) + '%';
      }
      if (head) {
        var menuOpen = menu && menu.classList.contains('open');
        if (!menuOpen) {
          if (y > lastY + 2 && y > 140) head.classList.add('bbc-header-hidden');
          else if (y < lastY - 2) head.classList.remove('bbc-header-hidden');
        }
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ── 5. SCROLL REVEAL (.bbc-reveal injectés) ── */
  function initScrollReveal() {
    var els = $$('.bbc-reveal');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── 6. LABELS DE SECTION ────────────────────
     Le thème pose déjà des .eyebrow natifs sur chaque section :
     on n'injecte un label QUE si la section n'en a aucun. */
  function injectSectionLabels() {
    var map = {
      'Pièces du moment': 'LA SÉLECTION',
      'Les mains derrière les pièces': 'NOS CRÉATEURS',
      'Pourquoi Bleu Blanc Couture': 'NOTRE HISTOIRE',
      'Réservez votre essayage privé': 'SUR RENDEZ-VOUS',
      "L'exigence, en trois promesses": 'NOS ENGAGEMENTS',
      "Lectures de l'atelier": 'LE JOURNAL',
      'Rejoindre BBC': 'LA NEWSLETTER'
    };
    $$('h2').forEach(function (h2) {
      var txt = h2.textContent.trim();
      for (var key in map) {
        if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
        if (txt.indexOf(key) === -1) continue;
        var container = (h2.closest && (h2.closest('.section') || h2.closest('section'))) || h2.parentNode;
        if (container && !container.querySelector('.eyebrow, .bbc-section-label')) {
          var lbl = doc.createElement('span');
          lbl.className = 'bbc-section-label bbc-reveal';
          lbl.textContent = map[key];
          h2.parentNode.insertBefore(lbl, h2);
        }
        break;
      }
    });
  }

  /* ── 7. CARTE « VRAI PRIX » — tilt 3D + reflet ── */
  function initVpCards() {
    var cards = $$('[data-bbc-tilt]');
    if (!cards.length) return;
    cards.forEach(function (card) {
      if (!prefersReduced && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { card.classList.add('in'); io.unobserve(card); }
          });
        }, { threshold: 0.3 });
        io.observe(card);
      } else {
        card.classList.add('in');
      }
      if (!finePointer || prefersReduced) return;
      var zone = card.parentNode;
      zone.addEventListener('mousemove', function (e) {
        var r = zone.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateX(' + (-py * 7).toFixed(2) + 'deg) rotateY(' + (px * 7).toFixed(2) + 'deg)';
        card.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
      });
      zone.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 0.6s ease';
        card.style.transform = 'rotateX(0deg) rotateY(0deg)';
        setTimeout(function () { card.style.transition = ''; }, 620);
      });
    });
  }

  /* ── INIT ─────────────────────────────────────────── */
  /* ── 8. PASSEPORT DE FABRICATION — flip + tilt + reflet ── */
  function initPassCards() {
    var cards = $$('[data-bbc-pass]');
    if (!cards.length) return;
    cards.forEach(function (card) {
      function flip() {
        var f = card.classList.toggle('flipped');
        card.setAttribute('aria-pressed', f ? 'true' : 'false');
      }
      card.addEventListener('click', flip);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); }
      });
      if (!finePointer || prefersReduced) return;
      var zone = card.parentNode;
      zone.addEventListener('mousemove', function (e) {
        var r = zone.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateX(' + (-py * 15).toFixed(2) + 'deg) rotateY(' + (px * 15).toFixed(2) + 'deg)';
        card.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
      });
      zone.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 0.6s ease';
        card.style.transform = 'rotateX(0deg) rotateY(0deg)';
        setTimeout(function () { card.style.transition = ''; }, 620);
      });
    });
  }

  /* ── 9. INTÉGRATIONS DIFFÉRÉES (Calendly…) ────
     Le code d'intégration est inerte dans un <template> et n'est
     injecté qu'à l'approche du viewport — gros gain de performance. */
  function initLazyEmbeds() {
    var hosts = $$('[data-bbc-embed]');
    if (!hosts.length) return;
    function inject(host) {
      var tpl = host.querySelector('template');
      if (!tpl) return;
      var holder = doc.createElement('div');
      holder.appendChild(tpl.content.cloneNode(true));
      tpl.parentNode.removeChild(tpl);
      $$('script', holder).forEach(function (s) {
        var n = doc.createElement('script');
        for (var i = 0; i < s.attributes.length; i++) {
          n.setAttribute(s.attributes[i].name, s.attributes[i].value);
        }
        n.text = s.text || '';
        s.parentNode.replaceChild(n, s);
      });
      while (holder.firstChild) host.appendChild(holder.firstChild);
    }
    if (!('IntersectionObserver' in window)) { hosts.forEach(inject); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { inject(entry.target); io.unobserve(entry.target); }
      });
    }, { rootMargin: '900px 0px' });
    hosts.forEach(function (h) { io.observe(h); });
  }

  function init() {
    splitHeroTitle();
    initScrollProgress();
    initVpCards();
    if (typeof requestIdleCallback !== 'undefined') { requestIdleCallback(initPassCards); } else { setTimeout(initPassCards, 200); }
    initLazyEmbeds();
    injectSectionLabels();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(initScrollReveal);
    });
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
